import axios from "axios"

export function getAdvertiserCategories(token) {
    return axios.get(process.env.REACT_APP_API_URL + `/getAdvertiserCategories`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}
